import React, { Component } from "react";

export default class footer extends Component {
  render() {
    return (
      <>
        <div class="footer out-footer">
          <div class="copyright">
            <p>
              Copyright © by
              <a href="https://bajibet777.com" target="_blank">
                bajibet777.com
              </a>
              2026
            </p>
          </div>
        </div>
      </>
    );
  }
}
